module.exports = __webpack_public_path__ + "static/media/ssai_partners.9ab46f1e.svg";